import { Controller } from "@hotwired/stimulus"

// Sekcja przypiętych ważnych maili: zwijanie oraz masowe zaznaczanie tej grupy.
// - Zwijanie: klik w pasek chowa/pokazuje ramki przypiętych maili (po ID index_email_<id>) oraz
//   separator, przez "hidden" (display:none) — elementy ZOSTAJĄ w DOM, więc bulk i akcje działają
//   dalej. Kontroler siedzi na <ul>, struktura płaska ul > li (bez owijania). Stan zwinięcia
//   zapisywany per użytkownik przez IntumJs.setField, żeby przetrwał między wejściami.
// - Zaznaczanie: checkbox w nagłówku zaznacza/odznacza tylko checkboxy przypiętych wierszy.
//   Master odzwierciedla też zmiany z zewnątrz (ogólny "zaznacz wszystkie" bulk zmienia checkboxy
//   po cichu, bez eventu, więc synchronizujemy na klik w obrębie dokumentu).
export default class extends Controller {
  static targets = ["separator", "icon", "selectAll"]
  static values = { collapsed: Boolean, key: String, ids: String }

  connect() {
    this.apply()
    this.syncSelectAll = this.syncSelectAll.bind(this)
    document.addEventListener("click", this.syncSelectAll)
    this.syncSelectAll()
  }

  disconnect() {
    document.removeEventListener("click", this.syncSelectAll)
  }

  // klik w pasek — przełącz zwinięcie i zapisz ostatni stan usera
  toggle() {
    this.collapsedValue = !this.collapsedValue
    this.apply()
    IntumJs.setField(this.keyValue, this.collapsedValue, { target: "user_setting", check: false })
  }

  // odwzorowanie stanu zwinięcia na DOM (bez zapisu) — używane w connect i po toggle
  apply() {
    this.collapsibleElements().forEach((el) => el.classList.toggle("hidden", this.collapsedValue))
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", this.collapsedValue)
    }
  }

  // elementy chowane przy zwijaniu: ramki przypiętych maili (po ID — odporne na turbo re-render,
  // bo id="index_email_<id>" jest stałe) oraz statyczny separator (target, nie jest re-renderowany)
  collapsibleElements() {
    const frames = this.idsValue
      .split(",")
      .filter(Boolean)
      .map((id) => this.element.querySelector(`#index_email_${id}`))
      .filter(Boolean)
    return [...frames, ...this.separatorTargets]
  }

  // checkbox nagłówka — zaznacz/odznacz wszystkie przypięte. Klikamy pojedyncze checkboxy (cb.click),
  // bo to niezawodnie zaznacza i odświeża licznik bulka. click ma jednak skutki uboczne: focusuje
  // element (wizualne "owinięcie") i ustawia bulkową kotwicę shift (lastElement) — oba czyścimy niżej,
  // żeby master przypiętych zachowywał się jak ogólny "zaznacz wszystkie". stopPropagation — nie zwijaj sekcji.
  toggleAll(event) {
    event.stopPropagation()
    const boxes = this.pinnedCheckboxes()
    // decydujemy ze stanu wierszy, nie z event.target.checked — przy indeterminate master
    // natywny .checked bywa niestabilny; jeśli nie wszystkie zaznaczone → zaznacz wszystkie.
    const shouldCheck = !(boxes.length > 0 && boxes.every((cb) => cb.checked))
    boxes.forEach((cb) => {
      if (cb.checked !== shouldCheck) cb.click()
    })
    // usuń focus (znika "owinięcie") i bulkową kotwicę shift zostawione przez cb.click()
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur()
    this.resetBulkAnchor()
    this.syncSelectAll()
  }

  // master przypiętych nie zostawia kotwicy shift w bulku (jak ogólny "zaznacz wszystkie", który zeruje
  // lastElement) — inaczej kolejny shift-click liczyłby zakres od ostatniego klikniętego przypiętego
  resetBulkAnchor() {
    const bulkEl = this.element.closest("[data-controller~=\"bulk-options-advanced\"]")
    if (!bulkEl) return

    const ctrl = this.application.getControllerForElementAndIdentifier(bulkEl, "bulk-options-advanced")
    if (ctrl) ctrl.lastElement = null
  }

  // synchronizacja mastera ze stanem checkboxów przypiętych (po każdym kliknięciu na stronie —
  // łapie też ogólny "zaznacz wszystkie" bulk, który zmienia checkboxy bez zdarzenia change)
  syncSelectAll() {
    if (!this.hasSelectAllTarget) return

    const boxes = this.pinnedCheckboxes()
    const checked = boxes.filter((cb) => cb.checked).length
    this.selectAllTarget.checked = boxes.length > 0 && checked === boxes.length
    this.selectAllTarget.indeterminate = checked > 0 && checked < boxes.length
  }

  // checkboxy opcji masowych przypiętych maili — szukamy po ID (value), a NIE po data-target,
  // bo po akcji bulk turbo re-renderuje wiersz (index_email_<id>) bez pin_row i target znika.
  // Wyszukanie po value jest odporne na re-render (jak ogólny bulk querySelectorAll na liście).
  pinnedCheckboxes() {
    return this.idsValue
      .split(",")
      .filter(Boolean)
      .map((id) => this.element.querySelector(`input[name='ids[]'][value='${id}']`))
      .filter(Boolean)
  }
}
